// @ts-nocheck
//#region imports
//#region react/redux
import React, { Component } from "react"
import Scrollbars from "react-custom-scrollbars-2"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
//#endregion react/redux

//#region components
import MainSection from "../../components/layout/MainSection"
import Footer from "../../components/Footer"
import DataCard from "../../components/layout/DataCard"
import NexusMenu from "../../components/layout/NexusMenu"
import NexusTable from "../../components/layout/NexusTable"
import NexusCommitteesTable from "../../components/layout/NexusCommitteesTable"
import Navbar from "../../components/layout/DashboardNavbar"
import TitleBar from "../../components/layout/TitleBar"
import ErrorModal from "../../components/ErrorModal"
import MaxApptsModal from "../../components/MaxApptsModal"
import WhyRegisterModal from "../../components/WhyRegisterModal"
import SubscriptionFeatureModal from "../../components/SubscriptionFeatureModal"
import MaxFavouritesReachedModal from "../../components/MaxFavouritesReachedModal"
import ImportingModal from "../../components/ImportingModal"
import HomePageTabs from "../../components/HomePageTabs"
import ProgressModal from "../../components/NexusModals/ProgressModal"
import CompanyData from "../../components/layout/NexusMenu/CompanyData"
import PersonData from "../../components/layout/NexusMenu/PersonData"
import initStats from "../../components/layout/InitStats"
import { sortRows } from "../../components/NumerableTable"
import { createNexusHeadersData } from "../../components/layout/NexusTable/createNexusHeadersData"
import { createNexusRowDataForCsv } from "../../components/layout/NexusTable/createNexusRowDataForCsv"
import { getFilteredItems } from "../../components/layout/NexusTable/GetFilteredItems"
import { createNexusCommitteesRowData } from "../../components/layout/CommitteesTable/createNexusCommitteesTableRows"
import { createNexusCommitteesHeadersData } from "../../components/layout/CommitteesTable/createNexusCommitteesTableHeaders"
import ExportCsvModal from "../../components/ExportCsvModal"
import StandardTrialModal from "../../components/StandardTrialModal"
import UrlTrialModal from "../../components/UrlTrialModal"
import checkboxSettingsForCsv from "../../components/layout/CheckboxSettingsForCsv"
import { wouldExceedMaxCount } from "../home/helpers/homeFunctions"
import { analyseUrl, fetchId, findKind, getKind, newUrl, validateTableInfoPage } from "../home/helpers/commonFunctions"
import { getSecondLevelIdsList, scndLvlCheckboxChecked } from "../home/helpers/secondLevelFuncs"
import { changeCheckbox, getChecked, setAllCheckboxes } from "../home/helpers/checkboxFunctions"
//#endregion components

//#region modules
import { actions as advisersActions } from "../../modules/advisersModule"
import { actions as appActions } from "../../modules/appModule"
import { actions as commonActions } from "../../modules/commonModule"
import { actions as favActions } from '../../modules/favouritesModule'
import { actions as lseActions } from '../../modules/lseModule'
import { actions as newsActions } from "../../modules/newsModule"
import { actions as nexusActions } from "../../modules/nexusModule"
import { actions as searchActions } from "../../modules/searchModule"
import { actions as synopsisActions } from "../../modules/synopsisModule"

import { formatDate_D_MMM_YYYY, getAddress, getMapAddress, getStatusLevel, getFullStatus, getNameProp } from "../../modules/utilities"
import { exportToCsv } from "../../modules/exportToCsv"
import { selectors as userSelectors } from "../../modules/userModule"
//#endregion modules

//#region mui
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import Snackbar from "@mui/material/Snackbar"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import CircularProgress from '@mui/material/CircularProgress'

//#endregion mui

// import other
import HOOK from "../../components/hooks"
import history from "../../services/history"
import { createNexusD3, resizeNexusD3 } from "./d3/nexusD3"
import { createTimelineD3, resizeTimelineD3 } from "./d3/timelineD3"
import { BASE, CATEGORY, COLOR, FORMATTING, JARGON, KEY_VALUES, KIND, LAYOUT, LINKS, PATH, RADIO, STATUS, TAB, TABLE_BIT, TENSE_ENUM, SCROLLBAR, VIEW, CARD } from "../../modules/constants"
import COLUMNS from "../../modules/columns"
import { CHECKBOX } from "../../modules/checkbox_constants"
import { LoadFavouritesAndLSEs } from "../home/helpers/loadFavouritesAndLSEs"
import { notEmpty } from "../../modules/utilities"
import { NexusDashboard } from "./NexusDashboard"
import { NexusNews } from "./NexusNews"
import { getNodeConnectionsCount, getOrderSet } from "../../modules/nexusFuncs"
import getCheckboxMenu from "../../components/CheckboxMenus"
import NexusAdviserClientsTable from "../../components/layout/NexusTables/NexusAdviserClientsTable"
import { findCompaniesUsingAdviser, findCompanyByNumber } from "../../components/layout/NexusTables/NexusAdviserFunctions"
import { filterAdviserClientsByCheckbox } from "../../components/layout/FilterSearchResults"
//#endregion imports

const local = { cancelGetScndLvl: false }
let update = false
// let tableToD3 = false
let idsList = []

class NexusPage extends Component {

  //#region constructor
  constructor(props) {
    // console.clear()
    // console.log("%cNexusPage constructor: props: ", "background: #ccffcc", props)
    super()
    this.state = {
      showCsvModal: false,
      showMaxFavouritesReached: false,
      showWhyRegisterModal: false,
      showUnderDevelopmentModal: false,
      showSubscriptionFeatureModal: false,
      showStandardTrialModal: false,
      showUrlTrialModal: false,
      snackbarMessages: {},
    }
  }
  //#endregion constructor

  //#region React lifecycle methods
  componentDidMount = () => {
    // console.log(`%cNexusPage componentDidMount props: `, "background: #ffbcf9ff", this.props)
    this.props.app.setPage(this.constructor.name)

    // Ensure favourites and LSEs are loaded and synced
    LoadFavouritesAndLSEs(this.props)

    window.addEventListener("resize", this.actionOnResize) // this.testForPortraitChange)

    // there is no nexusData when we mount so no point in calling getSecondLevelIdsList
    if (this.urlAndPropsSynced()) {
      this.getData({ ...this.props })
    }

    if (this.props.urlTrialDaysLeft != null && !this.props.urlTrialModalShown) {
      this.setState({ showUrlTrialModal: true })
    } else if (this.props.features.Trial && !this.props.standardTrialModalShown) {
      this.setState({ showStandardTrialModal: true })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log("%cshouldComponentUpdate() nextProps: ", "background: #cddafcff", nextProps)

    // While changed.length < 2, add any changed props to the array
    const changed = []
    Object.entries(this.props).every(([key, val]) => {
      if (nextProps[key] !== val)
        changed.push(key)

      return changed.length < 2
    })

    // If the only location and match have changed, analyse and save the setting and return false
    if (changed.every((val, index) => val === ["location", "match"][index])) {
      this.props.common.saveSettings({ ...this.props, ...analyseUrl(this.props) })
    }

    return true
  }

  componentDidUpdate = (prevProps, prevState) => {
    // console.log(`%cNexusPage componentDidUpdate props: `, "background: #fce2abff", this.props)
    /*
    // Debug code for comparing current and next state
    Object.entries(this.props).forEach(([key, val]) =>
    prevProps[key] !== val && console.log(`Prop '${key}' changed`)
    )
    if (this.state) {
      Object.entries(this.state).forEach(([key, val]) =>
      prevState[key] !== val && console.log(`State '${key}' changed`)
      )
    }*/

    // This 'is the current BASE.COMPANY radio selection still valid' check only makes sense while we're
    // actually viewing the Company tab. Without this guard, viewing a Person page (where nexusData is a
    // person, so isAdviser/isLse are both false) would find radio[BASE.COMPANY] "invalid" any time it
    // wasn't left on Board/Connections, and dispatch a correction - but selectRadio applies eventTargetValue
    // to whichever tab is CURRENTLY active, so it would overwrite radio[BASE.PERSON] instead, leaving
    // radio[BASE.COMPANY] untouched. That correction would fire again on every subsequent update (since the
    // thing it's actually checking never gets fixed), which is an infinite render loop -
    // "Maximum update depth exceeded".
    if (this.props.tabIndex === TAB[BASE.COMPANY].INDEX) {
      // Sets isAdviser variable to true if the company is an adviser (i.e. has the company in its advisersMeta)
      const companyNumber = this.props.nexusData?.nodes?.[0]?.entity?.companyProps?.number
      const isAdviser = (this.props.advisersMeta ?? []).some(
        item => item.companyNumber === companyNumber
      )
      const isLse = !!this.props.nexusData?.nodes?.[0]?.entity?.companyProps?.lse

      // Reset radio to Board if the current selection is not available for this company type:
      //   Adviser-only (not lse): only BOARD, CONNECTIONS and ADVISER_CLIENTS are valid
      //   Private (not lse, not adviser): only BOARD and CONNECTIONS are valid
      //   LSE (adviser or not): all values valid — no reset needed
      const currentRadio = this.props.radio[BASE.COMPANY]
      const radioInvalid = isLse
        ? false
        : isAdviser
          ? currentRadio !== RADIO[BASE.COMPANY].BOARD
            && currentRadio !== RADIO[BASE.COMPANY].CONNECTIONS
            && currentRadio !== RADIO[BASE.COMPANY].ADVISER_CLIENTS
          : currentRadio !== RADIO[BASE.COMPANY].BOARD
            && currentRadio !== RADIO[BASE.COMPANY].CONNECTIONS

      if (radioInvalid) {
        this.props.common.selectRadio({ ...this.props, eventTargetValue: RADIO[BASE.COMPANY].BOARD })
      }
    }

    // Ensure favourites and LSEs are loaded and synced
    LoadFavouritesAndLSEs(this.props)

    if (this.urlAndPropsSynced()) {
      if (local.cancelGetScndLvl) {
        local.cancelGetScndLvl = false
        this.props.nexus.saveSettings({ ...this.props, cancelGetScndLvl: true })
      }
      else
        if (this.props.nexusStatus === STATUS.NEXUS.CLEAR) {
          if (idsList.length === 0) {
            // this.props.checkboxes must correctly reflect the url before we do this!!
            // (this.urlAndPropsSynced() ensures this)
            idsList = getSecondLevelIdsList(this.props)

            if (idsList.length > 0 && this.props.showProgressModal === false)
              this.props.nexus.setShowProgressModal(true)
            else if (idsList.length === 0 && this.props.showProgressModal === true)
              this.props.nexus.setShowProgressModal(false)
          }
          this.getData({ ...this.props })
        } else
          if (this.props.cancelGetScndLvl === true)
            this.getData({ ...this.props })
    }
  }

  componentWillUnmount = () => {
    // console.log("componentWillUnmount")
    window.removeEventListener("resize", this.actionOnResize) // this.testForPortraitChange)
  }
  //#endregion React lifecycle methods

  urlAndPropsSynced = () => {
    // If the url does not match the props, save new props to
    // common state - causing update - and return false.
    // Else return true.
    const urlProps = analyseUrl(this.props)
    if (newUrl(this.props, urlProps)) // has the url changed?
    {
      update = true
      this.props.common.saveSettings({ ...this.props, ...urlProps })
      return false
    } else
      return true
  }

  //#region get data
  getData = props => {
    // console.log(`getData props: `, props)
    const { match, checkboxes, nexusView, radio } = this.props
    const { companyId, personId } = match.params
    const uriId = companyId || personId
    const idsListPop = idsList.length > 0 ? idsList.pop() : null

    if (this.props.cancelGetScndLvl)
      this.props.nexus.cancelGetEntities({
        ...props,
        uriId,
        hubId: uriId,
        handleOnClick: this.handleOnClickNode,
        nexusView,
        checkboxes,
        radio,
      })
    else {

      if (this.props.nexusStatus === STATUS.NEXUS.CLEAR && this.pageNotUpToDate({ idsListPop, nexusView, props, radio, uriId })) {
        update = false

        if (this.props.features.Favourites && !notEmpty(this.props.favourites)) {
          // If there are favourites, wait for them to load before getting entities
          // else, we will need to rebuild the node data again after syncing
        } else
          this.props.nexus.getEntities(
            {
              ...props,
              uriId,
              hubId: uriId,
              idsList: idsListPop ? [uriId, idsListPop.ids] : [uriId],
              handleOnClick: this.handleOnClickNode,
              nexusView,
              checkboxes,
              radio,
              status: STATUS.NEXUS.RECEIVING,
            })
      }
    }
  }
  //#endregion get data
  pageNotUpToDate = ({ idsListPop, nexusView, props, radio, uriId }) => {
    return ((props.statusCode === 200 && props.nexusData.chId !== uriId)
      || nexusView !== this.props.nexusView
      || radio != this.props.radio
      || update === true
      || idsListPop !== null
      // The node graph currently held in nexusData was last built for either the Connections
      // (2nd degree) view or not - if that no longer matches the current radio selection, the
      // graph is stale (eg it may have been silently rebuilt without 2nd degree nodes by an
      // unrelated fetch while on Board/Committees/etc) and must be rebuilt, even when every
      // entity is already 'acquired' and so there is nothing new to fetch over the network.
      || props.nexusData.enableSecondLevel !== scndLvlCheckboxChecked(props))
  }

  getPreviousNames = companyProfile => companyProfile
    ? companyProfile.previousCompanyNames?.map(name => name.name).join(", ")
    : ""

  getActivities = companyProfile => companyProfile
    ? !companyProfile.activities?.length
      ? "none listed"
      : companyProfile.activities.map(activity => activity.toLowerCase()).join("; ")
    : JARGON.UNKNOWN

  getFromDate = companyProfile => companyProfile?.dateOfCreation
    ? formatDate_D_MMM_YYYY(companyProfile.dateOfCreation)
    : null

  getToDate = companyProfile => companyProfile?.dateOfCessation
    ? formatDate_D_MMM_YYYY(companyProfile.dateOfCessation)
    : null

  getGleifCreationDate = gleif => gleif?.creationDate
    ? formatDate_D_MMM_YYYY(gleif.creationDate)
    : null

  getHubEntityProperties = node => {
    let entity = node.entity
    const { companyProps } = entity
    const companyProfile = companyProps?.companyProfile
    const lseProps = companyProps?.lse
    // console.log("companyProfile: ", companyProfile)
    // console.log("companyProfile.registeredOfficeAddress", companyProfile.registeredOfficeAddress)
    // console.log("node: ", node)
    // console.log("entity: ", entity)
    // console.log("connectionCounts: ", node.connectionCounts)

    return {
      name: getNameProp.toPresent(node.entity?.name),
      companyNumber: entity.companyProps?.number || JARGON.UNKNOWN,
      companyRegCountry: lseProps?.countryCode ? lseProps.countryCode : "GB",
      previousNames: this.getPreviousNames(companyProfile),
      periodEndOn: companyProfile?.accounts?.lastAccounts?.periodEndOn,
      activities: this.getActivities(companyProfile),
      address: companyProfile?.registeredOfficeAddress?.shortAddress ?? entity.address?.shortAddress,
      fullAddress: getAddress(companyProfile?.registeredOfficeAddress ?? entity.address),
      mapAddress: getMapAddress(companyProfile?.registeredOfficeAddress ?? entity.address),
      companyShortAddress: companyProfile?.registeredOfficeAddress?.shortAddress ?? JARGON.UNKNOWN,
      companyPostcode: companyProfile?.registeredOfficeAddress?.postcode ?? JARGON.UNKNOWN,
      status: getFullStatus(entity),
      companyType: companyProfile?.type ?? JARGON.UNKNOWN,
      fromDate: this.getFromDate(companyProfile) ?? this.getGleifCreationDate(lseProps?.gleif) ?? JARGON.UNKNOWN,
      toDate: this.getToDate(companyProfile),
      connectionCounts: node.connectionCounts,
      pdfLink: node.filings?.length > 0 ? node.filings[0].pdfLink : null,
      xhtmlLink: node.filings?.length > 0 ? node.filings[0].xhtmlLink : null,
      isFavourite: node.entity.isFavourite,
      lseProps,
      chIds: node.entity?.ids.filter(id => id.length === 27),
      lsePerson: !!entity?.ids.find(id => id.length === 32),
      ...this.getPersonInfo(entity.personInfo),
    }
  }

  getPersonInfo = personInfo => personInfo ||
  {
    dateOfBirth: null,
    nationality: JARGON.UNKNOWN,
    countryOfResidence: JARGON.UNKNOWN,
    sex: JARGON.UNKNOWN,
  }
  //#endregion get data elements

  //#region logic & utility functions
  actionOnResize = () => {
    const { nexusData, radio, tabIndex } = this.props

    // Diagram/Timeline are only ever mounted for these kinds (see 'showViewButtons' in render()) -
    // resizing any other kind (Dashboard/Committees/News/AdviserClients) would hit a stale/unmounted D3 instance
    const showsDiagramOrTimeline = tabIndex === TAB[BASE.COMPANY].INDEX
      ? radio[BASE.COMPANY] === RADIO[BASE.COMPANY].BOARD || radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS
      : tabIndex === TAB[BASE.PERSON].INDEX
        ? radio[BASE.PERSON] === RADIO[BASE.PERSON].ROLES || radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS
        : false

    if (nexusData.nodes.length > 0 && showsDiagramOrTimeline) {
      if (this.props.nexusView === VIEW.D3)
        resizeNexusD3()
      else if (this.props.nexusView === VIEW.TIMELINE)
        resizeTimelineD3()
    }
  }

  statusCodeNot200 = () => {
    return (<div>
      <ErrorModal
        show={true}
        statusCode={this.props.statusCode}
        reasonPhrase={this.props.reasonPhrase}
        customReason={this.props.customReason}
        onHide={() => {
          this.props.nexus.setShowErrorModal({ statusCode: 200 })
          history.push(this.props.previousUrl)
        }
        }>
      </ErrorModal>
    </div>)
  }

  // this.setAllCheckboxes calls the imported setAllCheckboxes with added props
  setAllCheckboxes = props =>
    setAllCheckboxes({ ...this.props, ...props })

  //#endregion logic & utility functions

  //#region snackbars
  addSnackbarMessage = message => {
    this.setState(state => ({
      snackbarMessages: { ...state.snackbarMessages, ["m" + Object.keys(state.snackbarMessages).length]: { message, open: true } }
    }))
  }

  handleCloseSnackbar = key => (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({ snackbarMessages: { ...this.state.snackbarMessages, [key]: { ...this.state.snackbarMessages[key], open: false } } })
  }

  showSnackbars = () => {
    return (
      Object.keys(this.state.snackbarMessages).map(key => (
        <Snackbar
          key={key}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={this.state.snackbarMessages[key].open}
          autoHideDuration={2000}
          onClose={this.handleCloseSnackbar(key)}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={<span id="message-id">{this.state.snackbarMessages[key].message}</span>}
          action={[
            <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleCloseSnackbar(key)}>
              <CloseIcon />
            </IconButton>
          ]}
        />
      ))
    )
  }
  //#endregion snackbars

  //#region event handlers
  handleOnClickNode = entity => {
    // console.log('handleOnClickNode entity:', entity)
    const pathname = `${entity.category}/${entity.ids.join(",")}`
    this.props.common.selectRow({ ...this.props, pathname })
  }

  handleOnClickFavourite = favouritesEnabled => {
    // console.log("favouritesEnabled: " + favouritesEnabled)
    favouritesEnabled
      ? this.handleOnClickFavouriteEnabled()
      : history.push(`/${PATH.LOGIN}`)
  }

  handleOnClickFavouriteEnabled = () => {
    const entity = this.props.nexusData.nodes[0].entity
    this.toggleIsFavourite(entity)
  }

  toggleIsFavourite = (entity) => {
    const { advisersMeta, entities, favourites, lseCompaniesMeta, lsePeopleMeta, newsMeta, searchResults } = this.props
    const { category, companyProps, ids } = entity
    const isFavourite = !entity.isFavourite
    const _id = fetchId(ids)

    // If the entity is currently a favourite, removed from favourites
    if (entity.isFavourite) {
      this.props.fav.delete(category, _id)
      this.addSnackbarMessage(`Removed from favourites`)
    } else {// If not currently a favourite, then we add to favourites (conditional)
      if (!this.props.features.Developer && wouldExceedMaxCount(entity, favourites))
        this.setState({ showMaxFavouritesReached: true })
      else {
        this.props.fav.add({ entity, entities })
        this.addSnackbarMessage(`Added to favourites`)
      }
    }

    // Set entity isFavorite property and sav ethe entities
    entity.isFavourite = isFavourite
    this.props.nexus.saveEntities2(entities)

    // Person/company might be in search results so process these
    this.props.search.updateIsFavouriteUsingIds({ searchResults, ids, isFavourite })

    // If the category is a company, then it might be an LSE
    if (category === CATEGORY.COMPANY) {
      this.props.lse.setIsFavouriteById({ lseCompaniesMeta, _id, isFavourite })
      this.props.advisers.setIsFavouriteById(advisersMeta, _id, isFavourite)

      const lei = companyProps?.lse?.lei

      if (lei)
        this.props.news.setFavouriteByLei({ newsMeta, lei, isFavourite })
    }
    else if (category === CATEGORY.PERSON)
      this.props.lse.setIsFavouritePersonById({ lsePeopleMeta, _id, isFavourite })
  }

  handleToggleIsFavourite = ({ row }) => {
    let pointer = this.props.entities.pointers[row._id]
    let entity = this.props.entities.items[pointer]
    this.toggleIsFavourite(entity)
  }

  handleToggleAdviserClientFavourite = ({ row }) => {
    const { entities } = this.props
    const entityId = row.ids?.[0] || row._id
    const pointer = entities.pointers[entityId]
    if (pointer !== undefined) {
      this.toggleIsFavourite(entities.items[pointer])
      return
    }
    const entity = {
      _id: entityId,
      category: CATEGORY.COMPANY,
      ids: row.ids,
      isFavourite: row.isFavourite,
      name: {
        original: row.title,
        toMatch: row.title,
        toPresent: row.title,
        toSort: row.title,
      },
    }
    this.toggleIsFavourite(entity)
  }

  handleChangeCheckbox = ({ bit, hook }) =>
    changeCheckbox({ ...this.props, bit, hook })

  handleChangeView = nexusView => {
    update = true
    this.props.common.selectRow({ ...this.props, nexusView })
  }

  handleChangeRadio = eventTargetValue => {
    this.props.common.selectRadio({ ...this.props, eventTargetValue })
  }

  handleLoggedOut = () => {
    this.setState({ showWhyRegisterModal: true })
  }

  handleNotSubscribed = () => {
    this.props.common.setLoginUrl()
    this.setState({ showSubscriptionFeatureModal: true })
  }

  handleNotDeveloper = () => {
    this.setState({ showUnderDevelopmentModal: true })
  }

  handleSelect = pathname => {
    // Handle selecting a row from the nexus table
    // NB: 'pathname' overides location.pathname
    this.props.common.selectRow({ ...this.props, pathname })
  }

  handleOrderTable = props => {
    // console.log('props:', props)
    this.props.common.setTableOrder(props)
  }

  handleCancelGetConnections = () => {
    // Clear the list of ids
    idsList = []
    // Set the local 'we are cancelling' variable
    local.cancelGetScndLvl = true
    this.props.common.selectRow({ ...this.props, checkboxes: this.props.previousCheckboxes })
  }

  // TableData used for csv
  getTableData = props => {
    // console.log('getTableData props:', props)
    const { items, kind } = props
    // Was hardcoded to KIND.NEXUS.COMPANY.COMMITTEES regardless of which page this actually is -
    // on the Person page that pulled in the Company committees column set (Officer, no Company
    // column) instead of the Person one (Company column, no Officer), silently dropping the
    // Company column from the Person-Committees CSV export even though the on-screen table (see
    // NexusPage's own committeesTableProps a few dozen lines down) already gets this right.
    const columns = COLUMNS.LANDSCAPE[kind]
    const orderSet = getOrderSet(props)
    const tableOrder = this.props.tableOrder[kind][orderSet]
    const stats = initStats()
    const isCompany = items[0].entity.category === CATEGORY.COMPANY
    const lseCompany = !!items[0].entity.companyProps?.lse
    const showLogos = false
    const tableProps = { ...this.props, ...props, columns, isCompany, lseCompany, showLogos, stats }
    const titleText = getNameProp.toPresent(items[0].entity.commonProps?.name ?? items[0].entity.name) // Handle legacy and revised entity model

    const headers = kind === KIND.NEXUS.PERSON.COMMITTEES || kind === KIND.NEXUS.COMPANY.COMMITTEES
      ? createNexusCommitteesHeadersData(tableProps)
      : createNexusHeadersData(tableProps)

    var rows = kind === KIND.NEXUS.PERSON.COMMITTEES || kind === KIND.NEXUS.COMPANY.COMMITTEES
      ? createNexusCommitteesRowData(tableProps)
      : createNexusRowDataForCsv(tableProps)

    rows = sortRows({ headers, rows, tableOrder })

    return { headers, rows, titleText }
  }

  getSuffix = kind => {
    switch (kind) {
      case KIND.NEXUS.COMPANY.BOARD:
        return JARGON.BOARD

      case KIND.NEXUS.COMPANY.COMMITTEES:
        return JARGON.COMMITTEES

      case KIND.NEXUS.COMPANY.COMMITTEES:
        return JARGON.COMMITTEES

      case KIND.NEXUS.PERSON.COMMITTEES:
        return JARGON.COMMITTEES

      case KIND.NEXUS.PERSON.ROLES:
      default:
        return JARGON.ROLES
    }
  }

  handleCsvExportSubmit = props => {
    // console.log('handleCsvExportSubmit props:', props)
    // 'portrait: false' so we always create all csv columns.
    const { kind, checkboxSettings } = props
    const { checkboxes, tabIndex } = this.props
    const { headers, rows: rawRows, titleText } = this.getTableData({ ...props, portrait: false, tabIndex, checkboxes })
    const rawRowsLength = rawRows.length
    const rows = rawRows.slice(0, KEY_VALUES.MAX_CSV_ROWS)
    const filename = `${titleText} - ${this.getSuffix(kind)}`
    exportToCsv({ filename, headers, rawRowsLength, rows, checkboxSettings })
  }
  //#endregion event handlers

  render() {
    // console.log(`render this.props: `, this.props)
    const { checkboxes, entities, features, nexusData, newsMeta, portrait, radio, rollups, standardTrialDaysLeft, tabIndex, the350club, urlTrialDaysLeft } = this.props

    const companyTab = tabIndex === TAB[BASE.COMPANY].INDEX
    const personTab = tabIndex === TAB[BASE.PERSON].INDEX

    const hubData = nexusData.nodes[0]
      ? this.getHubEntityProperties(nexusData.nodes[0])
      : null

    const lseCompany = !!hubData?.lseProps
    const lsePerson = !!hubData?.lsePerson

    // Determine the kind of nexus data we are showing
    // If NOT lse company or person, kind = KIND.NEXUS.COMPANY.BOARD or KIND.NEXUS.PERSON.ROLES respectively
    // Else use getKind to determine the kind from tabIndex and radio
    // kind is used for checkbox state and table ordering
    const kind = lseCompany || lsePerson
      ? getKind(tabIndex, radio)
      : tabIndex === TAB[BASE.COMPANY].INDEX
        ? radio[BASE.COMPANY] === RADIO[BASE.COMPANY].ADVISER_CLIENTS
          ? KIND.NEXUS.COMPANY.ADVISER_CLIENTS
          : radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS
            ? KIND.NEXUS.COMPANY.CONNECTIONS
            : KIND.NEXUS.COMPANY.BOARD
        : radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS
          ? KIND.NEXUS.PERSON.CONNECTIONS
          : KIND.NEXUS.PERSON.ROLES

    const companyCommittees = companyTab && lseCompany && radio[BASE.COMPANY] === RADIO[BASE.COMPANY].COMMITTEES
    const personCommittees = personTab && lsePerson && radio[BASE.PERSON] === RADIO[BASE.PERSON].COMMITTEES

    // If committees table assign nodes = nexusData.committeesNodes
    // Else, nodes = nexusData.nodes
    const nodes = personCommittees || companyCommittees
      ? nexusData.committeesNodes
      : nexusData.nodes

    const showPast = !!(CHECKBOX[HOOK.TENSE][TENSE_ENUM.PAST].BIT & checkboxes[HOOK.TENSE])
    const tense = getChecked({ checkboxes, hook: HOOK.TENSE })
    const showSecondDegree = companyTab
      ? radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS
      : radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS
    const numNodes = nodes.length

    const connections = numNodes > 0
      ? companyTab
        ? Object.filter(entities.connections, c => c.parentId === nodes[0].id)
        : Object.filter(entities.connections, c => c.childId === nodes[0].id)
      : null

    if (hubData?.mapAddress) {
      hubData.mapLink = LINKS.GOOGLE.MAPS + hubData.mapAddress
      hubData.gDocsViewerLink = LINKS.GOOGLE.VIEWER + hubData.pdfLink + "&embedded=true"
    }

    const category = nexusData.category
    const favouritesEnabled = features.Favourites
    const maxLseData = features.MaxLseData
    const isCompany = category === CATEGORY.COMPANY
    const showLseDataCard = features.ShowLseDataCard && lseCompany

    // Show index if premium user unless on company page and not showing second degree
    const showIndex = maxLseData && (!isCompany || showSecondDegree)
    const orderSet = getOrderSet({ checkboxes, portrait, radio, tabIndex })

    // Set nexusView to table for company and person committees
    const nexusView = companyCommittees || personCommittees
      ? VIEW.TABLE
      : this.props.nexusView

    // const isLtdOrPlc = hubData &&
    //   (hubData.companyType === "Limited Company" || hubData.companyType === "Public Limited Company")
    // if (hubData && hubData.companyType)
    //   console.log("company type: " + hubData.companyType + ", isLtdOrPlc: " + isLtdOrPlc)

    const nexusTitleProps = {
      // isLtdOrPlc,
      handleChangeView: view => this.handleChangeView(view),
      isCompany,
      lseCompany,
      numNodes,
      radio,
      showPast,
      showSecondDegree,
      tense,
    }

    const menuProps = {
      checkboxes,
      companyCommittees,
      features,
      handleChangeCheckbox: this.handleChangeCheckbox,
      handleChangeView: this.handleChangeView,
      handleLoggedOut: this.handleLoggedOut,
      handleNotSubscribed: this.handleNotSubscribed,
      handleOnClickFavourite: this.handleOnClickFavourite,
      handleRollupClick: e => this.props.app.toggleRollup(e),
      kind,
      nexusView,
      personCommittees,
      portrait,
      rollups,
      setAllCheckboxes: this.setAllCheckboxes,
      showSecondDegree,
      tabIndex,
      urlTrialDaysLeft,
    }

    // Handle Submit (OK) from the ExportCsvModal
    const handleCsvModalSubmit = props => {
      // console.log('handleCsvModalSubmit props:', props)
      const { delimiterValue, includeSettingsChecked } = props

      this.setState({ showCsvModal: false })
      const checkboxSettings = includeSettingsChecked ? checkboxSettingsForCsv({ checkboxes, kind, tabIndex }) : null
      this.handleCsvExportSubmit({ connections, delimiterValue, items: nodes, kind, maxLseData, radio, checkboxSettings, showIndex, showSecondDegree, tense })
    }

    // Handle clicking the Export to CSV button
    const handleCsvButtonClick = () => {
      // Number of rows (rowCount) is the number of nodes - 1 (the hub)
      this.setState({ showCsvModal: true, rowCount: nodes.length - 1 })
    }

    const handleSelectNewsRelease = row => {
      this.props.common.selectRow({ ...this.props, pathname: row.link })
    }

    const columns = portrait ? COLUMNS.PORTRAIT : COLUMNS.LANDSCAPE

    const dataProps = {
      brandColor: COLOR.BRAND.STD, // Possibly not required!!
      cheatSheet: features.CheatSheet,
      checkboxes,
      connections, // Hub node connections
      csvEnabled: features.ExportCsv,
      externalLinks: features.ExternalLinks,
      features,
      getStatusLevel,
      handleCsvButtonClick: () => handleCsvButtonClick(),
      handleNotSubscribed: this.handleNotSubscribed,
      hubData,
      kind,
      maxLseData,
      nodes,
      orderSet,
      portrait,
      radio,
      showLseDataCard,
      showPast,
      tableOrder: this.props.tableOrder, // used in cheatsheet
      the350club, // used in cheatsheet
      urlTrialDaysLeft,
    }

    const committeesTableProps = {
      checkboxes,
      columns: columns[isCompany ? KIND.NEXUS.COMPANY.COMMITTEES : KIND.NEXUS.PERSON.COMMITTEES],
      connections,
      favouritesEnabled,
      handleClickFavouriteIcon: row => this.handleToggleIsFavourite(row),
      handleOrderTable: props => this.handleOrderTable({ ...props, table: kind, orderSet }),
      handleSelect: this.handleSelect,
      items: nodes,
      kind,
      lsePerson,
      maxLseData,
      portrait,
      radio,
      showIndex: false,
      showSecondDegree: false,
      tabIndex,
      tableAnalysis: features.TableAnalysis,
      tableInfo: this.props.tableInfo,
      tableOrder: this.props.tableOrder[kind][orderSet],
      tense,
      totalResults: this.props.totalResults,
      the350club,
      zeroCommitteeNodes: nexusData.zeroCommitteeNodes,
    }

    // #region determine adviser and clients

    // Look up this company in advisersMeta regardless of radio state (needed for title bar and clients tab)
    const adviserInfo = isCompany && maxLseData
      ? findCompanyByNumber(this.props.advisersMeta, hubData?.companyNumber)
      : null

    // If the radio button is set to adviser clients, find the adviser company in advisersMeta using the company number in hubData.
    // If the company is not an adviser, adviser will be null
    const adviser = radio[BASE.COMPANY] === RADIO[BASE.COMPANY].ADVISER_CLIENTS
      ? adviserInfo
      : null

    const isAdviser = !!adviser

    // If the company is an adviser, find its clients by looking for companies in lseCompaniesMeta with adviserName
    // matching the name of the company in advisersMeta with company number matching hubData.companyNumber
    const clients = isAdviser
      ? filterAdviserClientsByCheckbox({
        items: findCompaniesUsingAdviser(this.props.lseCompaniesMeta.items, adviser.adviserName),
        checkboxes,
      })
      : []

    // constant for props to pass to the adviser clients table
    const adviserClientsTableProps = isAdviser
      ? {
        adviserName: adviser.adviserName,
        clients: clients,
        favouritesEnabled,
        handleClickFavouriteIcon: row => this.handleToggleAdviserClientFavourite(row),
        handleOrderTable: props => this.handleOrderTable({ ...props, table: kind, orderSet }),
        handleSelect: this.handleSelect,
        items: this.props.lseCompaniesMeta.items,
        portrait,
        tableInfo: this.props.tableInfo,
        tableOrder: this.props.tableOrder[kind][orderSet],
        the350club,
      }
      : {}
    // #endregion determine adviser and clients

    // Number of rows that will actually be rendered in the current table - NOT numNodes - 1 (the
    // number of distinct officer/PSC nodes). An officer can hold more than one capacity/role at the
    // same entity (see getFilteredItems / createNexusCommitteesRowData), and each capacity becomes
    // its own row, so the row count can exceed the node count. TitleBar's pagination controls (and
    // the page-clamping in handleChangePage below) must be sized against this, or a table whose
    // officers hold multiple roles each can need paging while the "count > 25" check that shows the
    // controls stays false, leaving the user stuck on a remembered page 2+ with no way back.
    const isNewsView = (lseCompany && maxLseData && radio[BASE.COMPANY] === RADIO[BASE.COMPANY].NEWS) ||
      (lsePerson && radio[BASE.PERSON] === RADIO[BASE.PERSON].NEWS)
    const isCommitteesView = maxLseData && (companyCommittees || personCommittees)

    const visibleRowCount = isAdviser
      ? clients.length
      : isCommitteesView
        ? createNexusCommitteesRowData({ ...committeesTableProps, isCompany, lseCompany, stats: initStats() }).length
        : isNewsView
          ? numNodes - 1
          : getFilteredItems({ checkboxes, connections, isCompany, items: nodes, maxLseData, showSecondDegree }).length

    // If lse company and radio button set to overview/dashboard, render dashboard.
    // Otherwise, render table, timeline etc
    const renderGroup = () => {
      if (isCompany && maxLseData && lseCompany && radio[BASE.COMPANY] === RADIO[BASE.COMPANY].DASHBOARD)
        return <NexusDashboard entity={nodes[0].entity} hubData={hubData} items={nodes} portrait={portrait} the350club={the350club} />

      // Guarded by companyTab for the same reason as the radioInvalid check in componentDidUpdate: a stale
      // radio[BASE.COMPANY] === ADVISER_CLIENTS while actually viewing the Person tab would otherwise
      // dispatch a correction that lands on radio[BASE.PERSON] instead (selectRadio always targets whichever
      // tab is currently active), doing nothing to fix the value this check itself depends on
      if (companyTab && this.props.radio[BASE.COMPANY] === RADIO[BASE.COMPANY].ADVISER_CLIENTS)
        if (!adviser)
          this.props.common.selectRadio({ ...this.props, eventTargetValue: RADIO[BASE.COMPANY].BOARD })
        else
          return < NexusAdviserClientsTable {...adviserClientsTableProps} />

      if ((lseCompany && maxLseData && radio[BASE.COMPANY] === RADIO[BASE.COMPANY].NEWS) || (lsePerson && radio[BASE.PERSON] === RADIO[BASE.PERSON].NEWS)) {
        return <NexusNews
          checkboxes={checkboxes}
          entity={nodes[0].entity}
          features={features}
          handleOrderTable={props => this.handleOrderTable({ ...props, table: kind, orderSet })}
          handleSelect={row => handleSelectNewsRelease(row)}
          hubData={hubData}
          items={nodes}
          kind={kind}
          newsMeta={newsMeta}
          portrait={portrait}
          radio={radio}
          showLogos={features.ShowLogos && lsePerson}
          tableOrder={this.props.tableOrder[kind][orderSet]}
        />
      }
      else if ((maxLseData && companyCommittees) || (maxLseData && personCommittees))
        return <NexusCommitteesTable {...committeesTableProps} />
      else
        switch (nexusView) {
          case VIEW.D3:
            // key={kind} forces a full remount (and so a fresh createNexusD3()) when switching between
            // Board/Roles and Connections - these are structurally different graphs, not incremental
            // updates to the same one, so the existing diagram can't just be patched in place
            return <NexD3 key={kind} />
          case VIEW.TIMELINE:
            // overflowY lives here (the bound-height flex item) rather than on the timeline-div
            // itself (see TimeD3 below), which just grows to fit the (possibly very tall) svg -
            // that's what gives this box something to scroll. In portrait, MainSection's own
            // Scrollbars already scrolls the whole page, so no separate inner scroll is added here.
            return <Box sx={{
              flex: 1, minWidth: 0,
              ...(portrait ? { borderTop: FORMATTING.border1, borderBottom: FORMATTING.border1 } : { overflowY: "scroll" }),
            }}>
              {/* key={kind}: see NexD3 above - same reasoning applies to the timeline */}
              <TimeD3 key={kind} portrait={portrait} />
            </Box>
          default:
            return <Box sx={{ flex: 1, minWidth: 0, ...(portrait ? { borderTop: FORMATTING.border1 } : {}) }}>
              <NexusTable
                checkboxes={checkboxes}
                connections={connections}
                favouritesEnabled={favouritesEnabled}
                handleClickFavouriteIcon={row => this.handleToggleIsFavourite(row)}
                handleOrderTable={props => this.handleOrderTable({ ...props, table: kind, orderSet })}
                handleSelect={this.handleSelect}
                items={nodes}
                kind={kind}
                lseCompany={lseCompany}
                lsePerson={lsePerson}
                maxLseData={maxLseData}
                portrait={portrait}
                radio={radio}
                showIndex={showIndex}
                showSecondDegree={showSecondDegree}
                tabIndex={tabIndex}
                tableAnalysis={features.TableAnalysis}
                tableInfo={this.props.tableInfo}
                tableOrder={this.props.tableOrder[kind][orderSet]}
                tense={tense}
                the350club={the350club}
              />
            </Box>
        }
    }

    const companyOrPersonData = () => (
      <
        // @ts-ignore
        Box id="data-cards" style={{
          width: portrait ? "" : LAYOUT.LANDSCAPE_MENU_WIDTH,
          minWidth: LAYOUT.LANDSCAPE_MENU_WIDTH,
          paddingLeft: LAYOUT.COLUMN_PADDING,
          backgroundColor: COLOR.BACKGROUND,
          // @ts-ignore
          overflowY: portrait ? "" : "auto",
        }}>
        {!portrait && <
          // @ts-ignore
          Scrollbars autoHide
          autoHideTimeout={SCROLLBAR.AH_TIMEOUT}
          autoHideDuration={SCROLLBAR.AH_DURATION}>
          {isCompany && <CompanyData {...dataProps} />}
          {!isCompany && <PersonData {...dataProps} />}
        </Scrollbars>}

        {portrait && isCompany && <CompanyData {...dataProps} />}
        {portrait && !isCompany && <PersonData {...dataProps} />}

      </Box>
    )

    // Determine whether to show the nexus menu
    // It is not shown for lse companies on the dashboard tab
    // or for lse persons on the news tab (these tabs have no checkboxes)
    // NB: kind is set to KIND.NEXUS.COMPANY.BOARD or KIND.NEXUS.PERSON.ROLES if not lse company or person
    const showNexusMenu = () => {
      switch (tabIndex) {
        case TAB[BASE.COMPANY].INDEX:
          return kind !== KIND.NEXUS.COMPANY.DASHBOARD
        case TAB[BASE.PERSON].INDEX:
          return kind !== KIND.NEXUS.PERSON.NEWS
        default:
          return false
      }
    }

    const menuArea = () => (
      <React.Fragment>
        {
          showNexusMenu() &&
          < NexusMenu portrait={portrait}>
            {getCheckboxMenu({ ...menuProps })}
          </NexusMenu>
        }
      </React.Fragment>
    )

    // Portrait-only: the view toggle buttons (Table/Diagram/Timeline), shown above the table
    // instead of inside the filters menu (which sits below the table in portrait)
    const showViewButtons = kind === KIND.NEXUS.COMPANY.BOARD || kind === KIND.NEXUS.PERSON.ROLES
      || kind === KIND.NEXUS.COMPANY.CONNECTIONS || kind === KIND.NEXUS.PERSON.CONNECTIONS

    const viewButtonsArea = () => (
      <Box sx={{ width: "100%", padding: `0px ${LAYOUT.COLUMN_PADDING}px`, marginBottom: "12px" }}>
        <NexusMenu.ViewButtons
          portrait={portrait}
          viewButtons={{ nexusView, handleChangeView: view => this.handleChangeView(view) }}
          features={features}
        />
      </Box>
    )

    // Handle changing the number of rows per page in the nexus table pagination
    const handleChangeRowsPerPage = event => {
      const tableInfoArray = JSON.parse(JSON.stringify(this.props.tableInfoArray))
      tableInfoArray[tabIndex].rowsPerPage = event.target.value
      this.props.common.saveTableInfo({ tableInfoArray })
    }

    // Handle changing page in the nexus table pagination
    const handleChangePage = (event, newPage) => {
      const tableInfoArray = JSON.parse(JSON.stringify(this.props.tableInfoArray))
      tableInfoArray[tabIndex].page = newPage
      tableInfoArray[tabIndex] = validateTableInfoPage({ ...tableInfoArray[tabIndex], count: visibleRowCount })
      this.props.common.saveTableInfo({ tableInfoArray })
    }

    return (
      <React.Fragment>

        {/* navbar */}
        < Navbar
          state={this.state}
          portrait={portrait}
        />

        {/* tabs bar */}
        {hubData && <HomePageTabs />}

        {hubData && <TitleBar
          advisersMeta={this.props.advisersMeta}
          common={this.props.common}
          companyNumber={hubData.companyNumber}
          count={visibleRowCount}
          favouritesEnabled={favouritesEnabled}
          features={features}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangeView={view => this.handleChangeView(view)}
          handleOnClickFavourite={this.handleOnClickFavourite}
          handleChangeRadio={eventTargetValue => this.handleChangeRadio(eventTargetValue)}
          isCompany={isCompany}
          isFavourite={hubData.isFavourite}
          lsePerson={hubData.lsePerson}
          lseProps={hubData.lseProps}
          kind={kind}
          maxLseData={maxLseData}
          nexusView={this.props.nexusView}
          portrait={portrait}
          radio={radio}
          showLogos={features.ShowLogos}
          starIcon={true}
          tabIndex={this.props.tabIndex}
          tableInfo={this.props.tableInfo}
          the350club={this.props.the350club}
          titleText={adviserInfo?.diffName ? `${hubData.name} (${adviserInfo.adviserName})` : hubData.name}
        />}

        <MainSection portrait={portrait} style={{ backgroundColor: CARD.CONTAINER.BACKGROUND_COLOR }}>

          {/* #region render data area */}
          {hubData && !portrait && companyOrPersonData()}

          <DataCard
            portrait={portrait}
            showCard={kind !== KIND.NEXUS.COMPANY.DASHBOARD}
          >
            {hubData && !portrait && menuArea()}

            {hubData && !portrait && showNexusMenu() && nexusView === VIEW.D3 &&
              <Divider orientation="vertical" flexItem sx={{ height: "auto", alignSelf: "stretch", width: "1px", border: "none", backgroundColor: COLOR.LIGHT_GREY }} />
            }

            {/* #region render data area menu */}

            {hubData && portrait && showNexusMenu() && showViewButtons && viewButtonsArea()}

            {/* Nexus table or D3 diagram */
              <React.Fragment>
                {numNodes > 0 && renderGroup()}

                {hubData && <ProgressModal
                  show={this.props.showProgressModal}
                  connections={getNodeConnectionsCount({ node: hubData, tense })}
                  idsList={idsList}
                  onCancel={() => this.handleCancelGetConnections()}
                />}

                {this.state.showStandardTrialModal && !this.props.standardTrialModalShown &&
                  standardTrialDaysLeft !== undefined &&
                  <StandardTrialModal />
                }

                {this.state.showUrlTrialModal && !this.props.urlTrialModalShown &&
                  <UrlTrialModal />
                }

              </React.Fragment>
            }

            {this.props.statusCode !== 200 && this.statusCodeNot200()}

            {hubData && portrait && menuArea()}
            {hubData && portrait && companyOrPersonData()}

            {/* #endregion render data area */}
          </DataCard>
        </MainSection >

        {/* #region modals etc */}
        <Footer urlSource={this.props.urlSource} />
        <ExportCsvModal
          rowCount={this.state.rowCount}
          open={this.state.showCsvModal}
          onClose={() => this.setState({ showCsvModal: false })}
          onSubmit={props => handleCsvModalSubmit(props)}
          title={"Export to CSV file"}
        />

        {hubData && <MaxFavouritesReachedModal
          open={this.state.showMaxFavouritesReached}
          onClose={() => { this.setState({ showMaxFavouritesReached: false }) }}
          category={isCompany ? "companies" : "people"}
          max={KEY_VALUES.MAX_FAVOURITES}
        />}

        <WhyRegisterModal
          open={this.state.showWhyRegisterModal}
          onClose={() => { this.setState({ showWhyRegisterModal: false }) }}
        />

        <SubscriptionFeatureModal
          open={this.state.showSubscriptionFeatureModal}
          onClose={() => { this.setState({ showSubscriptionFeatureModal: false }) }}
        />

        <ImportingModal
          open={this.props.nexusStatus === "receiving" && this.props?.skeleton?.appointmentCount > 50}
        />

        <MaxApptsModal
          open={this.props.totalResults > KEY_VALUES.MAX_APPTS}
          onClose={() => this.props.nexus.saveTotalResults({ totalResults: 0 })}
          totalResults={this.props.totalResults}
        />

        {this.showSnackbars()}

        {this.props.nexusStatus === "receiving" &&
          <CircularProgress
            style={{ position: "fixed", top: "calc(50% - 20px)", left: "calc(50% - 20px)", zIndex: 2 }}
          />}
        {/* #endregion modals etc */}

      </React.Fragment >
    )
  }
}

class NexD3 extends Component {
  // console.log("NexD3")
  // const { classes, item } = this.props

  componentDidMount = () => {
    // console.log("NexD3 componentDidMount")
    createNexusD3()

    update = true
    // tableToD3 = false
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    // console.log(`NexusPage *RENDER* props: `, this.props)
    return <Box id="nexus-div" className="nexus-div" />
  }
}

class TimeD3 extends Component {
  // console.log("TimeD3")
  // const { classes, item } = this.props

  componentDidMount = () => {
    // console.log("TimeD3 componentDidMount")

    createTimelineD3()

    update = true
    // tableToD3 = false
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    // console.log(`NexusPage *RENDER* props: `, this.props)
    return <Box id="timeline-div" className="timeline-div" />
  }
}

const mapStateToProps = ({ advisers, app, common, fav, lse, news, nexus, search, user }) => {
  return {
    // advisers
    advisersMeta: advisers.advisers,
    advisersSynced: advisers.synced,
    // app.
    features: app.features,
    rollups: app.rollups,
    isLoggedIn: !!app.token,

    // common.
    checkboxes: common.checkboxes,
    companyId: common.companyId,
    currentUrl: common.currentUrl,
    newsId: common.newsId,
    nexusView: common.nexusView,
    personId: common.personId,
    previousCheckboxes: common.previousCheckboxes,
    radio: common.radio,
    searchStringObj: common.searchStringObj,
    standardTrialModalShown: common.standardTrialModalShown,
    tabIndex: common.tabIndex,
    tableInfo: common.tableInfoArray[common.tabIndex ?? 0],
    tableInfoArray: common.tableInfoArray,
    tableOrder: common.tableOrder,
    the350club: common.the350club,
    urlSource: common.urlSource,
    urlTrialDaysLeft: common.urlTrialDaysLeft,
    urlTrialModalShown: common.urlTrialModalShown,

    // fav.
    favourites: fav.favourites,
    favouritesFetching: fav.isFetching,

    // lse.
    lseCompaniesMeta: lse.companiesMeta,
    lsePeopleMeta: lse.peopleMeta,

    // news.
    newsMeta: news.meta,

    // nexus.
    cancelGetScndLvl: nexus.cancelGetScndLvl,
    customReason: nexus.customReason,
    entities: nexus.entities,
    nexusData: nexus.data,
    nexusStatus: nexus.status,
    previousUrl: nexus.previousUrl,
    reasonPhrase: nexus.reasonPhrase,
    showErrorModal: nexus.showErrorModal,
    showProgressModal: nexus.showProgressModal,
    skeleton: nexus.skeleton,
    statusCode: nexus.statusCode,
    totalResults: nexus.totalResults,

    // search.
    searchResults: search.searchResults,
    scope: search.scope,

    // user.
    portrait: user.portrait,

    // user selectors
    standardTrialDaysLeft: userSelectors.getTrialDaysRemaining(user),
  }
}

export default connect(
  mapStateToProps,
  dispatch => ({
    advisers: bindActionCreators(advisersActions, dispatch),
    app: bindActionCreators(appActions, dispatch),
    common: bindActionCreators(commonActions, dispatch),
    fav: bindActionCreators(favActions, dispatch),
    lse: bindActionCreators(lseActions, dispatch),
    news: bindActionCreators(newsActions, dispatch),
    nexus: bindActionCreators(nexusActions, dispatch),
    search: bindActionCreators(searchActions, dispatch),
    synopsis: bindActionCreators(synopsisActions, dispatch),
  })
)(NexusPage)

